export default class Clouds {
    constructor() {
        this.layers = [];
        this.objects = [];
        this.world = document.getElementById( 'world' );
        this.viewport = document.getElementById( 'viewport' );
        this.d = -100;
        this.p = 400;
        this.worldXAngle = 0;
        this.worldYAngle = 0;
        this.cloudCount = 20;
        this.cloudSource = '/static/images/cloud.png';

        // Set the clouds
        this.generate();
    }

    show(callback) {
        this.callback = callback;
        this.viewport.className = 'viewport viewport--active';
        this.animate('in');
    }

    hide() {
        this.callback = null;
        this.animate('out');
        this.viewport.className = 'viewport';
    }

    animate(direction) {
        let incrementor = (direction === 'in') ? 30 : -30;

        this.d = this.d + incrementor;
        this.updateView();

        if (direction === 'in' && this.d > 700 || direction === 'out' && this.d <= -100) {
            if (this.callback) {
                this.callback();
            }
            return;
        }

        requestAnimationFrame(this.animate.bind(this, direction));
    }

    createCloud() {
        let div = document.createElement('div'),
            x = 256 - (Math.random() * 512),
            y = 256 - (Math.random() * 512),
            z = 256 - (Math.random() * 512),
            t = 'translateX( ' + x + 'px ) translateY( ' + y + 'px ) translateZ( ' + z + 'px )';

        div.className = 'cloudBase';
        this.styleTransform(div.style, t);
        this.world.appendChild( div );

        for( let j = 0; j < 5 + Math.round( Math.random() * 10 ); j++ ) {
            let cloud = document.createElement( 'img' ),
                x = 256 - ( Math.random() * 512 ),
                y = 256 - ( Math.random() * 512 ),
                z = 100 - ( Math.random() * 200 ),
                a = Math.random() * 360,
                s = .25 + Math.random(),
                t = 'translateX( ' + x + 'px ) translateY( ' + y + 'px ) translateZ( ' + z + 'px ) rotateZ( ' + a + 'deg ) scale( ' + s + ' )';

            cloud.style.opacity = 0;
            (function(img) {
                img.addEventListener('load', function() {
                    img.style.opacity = .8;
                });
            })(cloud);
            cloud.setAttribute('src', this.cloudSource);
            cloud.className = 'cloudLayer';

            x *= .2; y *= .2;
            cloud.data = {
                x: x,
                y: y,
                z: z,
                a: a,
                s: s,
                speed: .1 * Math.random()
            };
            this.styleTransform(cloud.style, t);

            div.appendChild(cloud);
            this.layers.push(cloud);
        }

        return div;
    }

    generate() {
        let objects = [];

        if (this.world.hasChildNodes()) {
            while (this.world.childNodes.length >= 1) {
                this.world.removeChild(this.world.firstChild);
            }
        }

        for(let j = 0; j < this.cloudCount; j++) {
            objects.push(this.createCloud());
        }
    }

    updateView() {
        let t = 'translateZ( ' + this.d + 'px ) rotateX( ' + this.worldXAngle + 'deg) rotateY( ' + this.worldYAngle + 'deg)';
        this.styleTransform(this.world.style, t);
    }

    // For cloud rotation.
    update (){
        for( let j = 0; j < this.layers.length; j++ ) {
            let layer = this.layers[ j ];
            layer.data.a += layer.data.speed;

            let t = 'translateX( ' + layer.data.x + 'px ) translateY( ' + layer.data.y + 'px ) translateZ( ' + layer.data.z + 'px ) rotateY( ' + ( - this.worldYAngle ) + 'deg ) rotateX( ' + ( - this.worldXAngle ) + 'deg ) rotateZ( ' + layer.data.a + 'deg ) scale( ' + layer.data.s + ')';

            this.styleTransform(layer.style, t);
        }

        requestAnimationFrame( this.update.bind(this) );
    }

    styleTransform(styleObj, transformStr) {
        styleObj.webkitTransform = transformStr;
        styleObj.MozTransform = transformStr;
        styleObj.msTransform = transformStr;
        styleObj.OTransform = transformStr;
        styleObj.transform = transformStr;
    }
}



/** WEBPACK FOOTER **
 ** ./frontend/js/componenets/clouds.js
 **/